import { render, staticRenderFns } from "./TerraIndigenaComSoja2324VegaParaguai.vue?vue&type=template&id=9b97d960&lang=pug"
import script from "./TerraIndigenaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports